export default function SplashScreen() {
    return (
        <div className="w-full bg-FB flex items-center justify-center h-screen">
            <h1 className="text-32 text-0D font-bold">Quick<span className="text-txt-red">Bite</span></h1>
        </div>
    )
}
